import { execGet } from '@/services/utils/RequestUtils';

import { InstrumentsAndBraintreeTokensApiResponse } from './PaymentInstrumentsApiResponse';

export async function getInstrumentsConfig(
  legalEntityNumber: number,
  accessToken: string,
) {
  const response = await execGet<InstrumentsAndBraintreeTokensApiResponse>(
    `paymentinstruments/newInstrumentConfig?legalEntityNumber=${legalEntityNumber}`,
    accessToken,
  );

  return response;
}
